import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { subscriptionSelectors, isFreePlanRoute } from "@/store/slices/subscription";
import SubscriptionPlansModal from "@/components/subscription/SubscriptionPlansModal";

const SubscriptionGuard = ({ children }) => {
  const [showChildren, setShowChildren] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const canAccess = useSelector((state) =>
    subscriptionSelectors.canAccessRoute(state, location.pathname)
  );

  useEffect(() => {
    if (isFreePlanRoute(location.pathname) || canAccess) {
      setShowChildren(true);
      setShowUpgradeModal(false);
    } else {
      setShowChildren(false);
      setShowUpgradeModal(true);
    }
  }, [location.pathname, canAccess]);

  const handleBackToPreviousPage = () => {
    navigate(-1);
    setShowUpgradeModal(false);
  };

  if (showChildren) {
    return children;
  }

  // Only render children if user can access the route,
  // otherwise show the subscription plans modal
  return showChildren ? (
    children
  ) : (
    showUpgradeModal && (
      <SubscriptionPlansModal 
        onClose={handleBackToPreviousPage} 
        showBackground={true}
      />
    )
  );
};

export { showSubscriptionPlansModal } from "@/components/subscription/SubscriptionPlansModal";

export default SubscriptionGuard;
